import React, { useMemo } from 'react';
import { Widget, Table, ColumnProps, FormatText, Button } from '@digital/ui';
import { ReportCicloOrcamentario } from '../../api/relatorios';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { Collapse } from 'antd';
import { getAllRelatorioCicloOrcamentarioBaseExcel, getAllRelatorioCicloOrcamentarioBaseExcelCrf } from '@app/api/relatorioProjetoPacote';
const { Panel } = Collapse;




interface GraficoCurvaPluriAnualProps {
  relatorio: ReportCicloOrcamentario;
  carregarTabela: boolean;
  exportarCurvaEconomicaPluriAnual?: boolean;
  projetoId?: string;
  contaResultado?: boolean;
}

const CurvaPluriAnualGrafico = (
  {
    relatorio,
    carregarTabela,
    exportarCurvaEconomicaPluriAnual,
    projetoId,
    contaResultado
  }: GraficoCurvaPluriAnualProps) => {



  const column: Highcharts.Options = {
    chart: {
      zoomType: 'xy'
    },
    title: {
      text: "Curva Plurianual"
    },
    colors: ['#08340D', '#80BDA6', '#E1865C'],
    xAxis: {
      categories: relatorio.categories,
      labels: {
        format: '{value}',
        style: {
          color: Highcharts.getOptions().colors[1]
        }
      },
      title: {
        text: 'Mes/Ano',
        style: {
          color: Highcharts.getOptions().colors[1]
        }
      },
      crosshair: true
    },
    yAxis: [
      {
        title: {
          text: 'Valor Acumulado',
          style: {
            color: Highcharts.getOptions().colors[0]
          }
        },
        labels: {
          formatter: function () { { return '' + this.value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) + ''; },
          style: {
            color: Highcharts.getOptions().colors[0]
          }
        },
        opposite: true
      },
      {
        labels: {
          formatter: function () { return '' + this.value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) + ''; },
          style: {
            color: Highcharts.getOptions().colors[1]
          }
        },
        title: {
          text: 'Valor Mensal',
          style: {
            color: Highcharts.getOptions().colors[1]
          }
        }
      }
    ],
    tooltip: {
      formatter: function () { return '<b>' + this.y.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) + '</b>'; }
    },
    labels: {
      items: [
        {
          style: {
            left: '15px',
            top: '18px',
            color:
              // theme
              (Highcharts.defaultOptions.title.style && Highcharts.defaultOptions.title.style.color) ||
              'black',
          },
        },
      ],
    },
    series: [
      {
        type: 'column',
        name: 'P',
        yAxis: 1,
        data: relatorio.serieDataOrcado,
        max: relatorio.serieDataOrcadoMax,
        min: 0
      },
      {
        type: 'column',
        name: 'R',
        yAxis: 1,
        data: relatorio.serieDataExecutado,
        max: relatorio.serieDataExecutadoMax,
        min: 0
      },
      {
        type: 'column',
        name: 'F',
        yAxis: 1,
        data: relatorio.serieDataForeCast,
        max: relatorio.serieDataForeCastMax,
        min: 0
      },
      {
        type: 'spline',
        name: 'P-Ac',
        yAxis: 0,
        data: relatorio.serieDataOrcadoLinha,
        max: relatorio.serieDataOrcadoLinha,
        min: 0
      },
      {
        type: 'spline',
        name: 'R-Ac',
        yAxis: 0,
        data: relatorio.serieDataExecutadoLinha,
        max: relatorio.serieDataForeCastLinhaMax,
        min: 0
      },
      {
        type: 'spline',
        name: 'F-Ac',
        yAxis: 0,
        data: relatorio.serieDataForeCastLinha,
        max: relatorio.serieDataForeCastLinhaMax,
        min: 0
      },
    ]
  };

  const colluns = useMemo(() => {
    const colunas: ColumnProps<any>[] = [];
    if (relatorio && relatorio.colluns && relatorio.colluns.length > 0) {
      relatorio.colluns.map((colluns, index) => {
        if (index === 0) {
          colunas.push({
            title: colluns.title,
            dataIndex: colluns.dataIndex,
            width: 250,
            align: 'center',
            fixed: 'left',
          });
        } else {
          colunas.push({
            title: colluns.title,
            dataIndex: colluns.dataIndex,
            width: 250,
            align: 'center',
          });
        }

      });
    }
    return colunas;
  }, [relatorio]);

  const btn = () => {

    const btns = [];

    if (exportarCurvaEconomicaPluriAnual === true && projetoId) {
      btns.push(<Button
        type="primary"
        name="btnExportar"
        icon="files-ms_excel"
        onClick={() => {
          if (contaResultado) {
            getAllRelatorioCicloOrcamentarioBaseExcelCrf(projetoId)
          } else {
            getAllRelatorioCicloOrcamentarioBaseExcel(projetoId)
          }
        }}>
        <FormatText id="data-export" uppercase transform={() => 'Exportar Relatório'} />
      </Button>)
    }

    return btns;
  }

  console.log(relatorio.resultTable)

  return (
    <>

      <Widget span={12} actions={[]}>
        {<HighchartsReact highcharts={Highcharts} options={column} />}
      </Widget>

      {relatorio && carregarTabela === true ? (
        <Widget
          actions={btn()}
        >
          <Table
            id="tableResultPluriAnual"
            columns={colluns}
            dataSource={relatorio.resultTable}
            rowKey={'id'}
            pagination={false} />
        </Widget>
      ) : (
        <> </>
      )}

    </>
  );
};

export default CurvaPluriAnualGrafico;
